import { apiWrapper } from "@/services/api";

// JSプラグイン
import moment from "@/services/moment";

export const validFramesWithQR = async (
  multiSheetValidIdsArray,
  location_id
) => {
  try {
    // 現在時刻+指定の文字列をBase64でエンコードしPOST API
    var currentTime = moment(new Date()).format();
    var securitySession = window.btoa(
      currentTime + "IXOYs2jMqCaymwbvsRw5QPGmecYUhggl"
    );

    await apiWrapper(
      "POST",
      `qrcode_frames?master_location_id=${location_id}&security_session=${securitySession}`,
      multiSheetValidIdsArray
    );
  } catch (err) {
    console.log("ERROR!! validFramesWithQR()");
    throw err;
  }
};
